// @flow
import moment from 'moment';
import * as React from 'react';
import { isValidABN, isValidACN } from 'abnacn-validator';
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
import createCompressor from 'redux-persist-transform-compress';
import type { Customer } from './types/Customer';

export function convertValueToNumber(value: any): number {
  return parseInt(value, 10);
}

export function convertValueToBoolean(value: string | boolean): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  return value === 'true';
}

export function formatDate(
  date: Date | string | number,
  short: boolean = false
): string {
  if (!date) {
    return '';
  }
  if (short) {
    return moment(date).format('D/M/YYYY');
  }

  return moment(date).format('Do MMMM, YYYY');
}

// Temporary solution to prevent duplicates
export function uniqueById(items: Object[]) {
  let ids = [];
  let output = [];

  items.forEach(item => {
    if (ids.indexOf(item.id) === -1) {
      output.push(item);
      ids.push(item.id);
    }
  });
  return output;
}

export function sortByName(
  array: Array<any> = [],
  sortValue: string = 'name',
  sortOrder: string = 'asc'
) {
  // $FlowFixMe
  return array.sort((a, b) => {
    if (!a[sortValue] || !b[sortValue]) {
      return 0;
    }
    const nameA = a[sortValue].toLowerCase(),
      nameB = b[sortValue].toLowerCase();
    if (sortOrder === 'asc') {
      if (
        nameA < nameB //sort string ascending
      )
        return -1;
      if (nameA > nameB) return 1;
      return 0; //default return value (no sorting)
    } else {
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) return 1;
      return 0;
    }
  });
}

export function noValidate(): void {
  return undefined;
}

export function validateFileName(value: string) {
  // eslint-disable-next-line no-useless-escape
  const regex = /^(?!\.)(?!com[0-9]$)(?!con$)(?!lpt[0-9]$)(?!nul$)(?!prn$)[^\|\*\?\\<>/$"]*[^\.\|\*\?\\<>/$"]+$/;
  return regex.test(value) ? undefined : 'File name is not valid';
}

export function validateRequired(value: ?string | ?number | ?boolean): ?string {
  return value === undefined ||
    value === '' ||
    value === null ||
    (typeof value === 'number' && isNaN(value))
    ? 'Required'
    : undefined;
}

export function validateTermsConditions(value: ?boolean): ?string {
  return value === undefined || value === false || value === null
    ? 'Please accept the Terms and Conditions'
    : undefined;
}

export function validateABN(value: string): ?string {
  if (value) {
    return isValidABN(value) ? undefined : 'Please enter a valid ABN';
  }
}

export function validateACN(value: string): ?string {
  if (value) {
    return isValidACN(value) ? undefined : 'Please enter a valid ACN';
  }
}

export function validatePhoneNumber(value: string): ?string {
  if (value) {
    const errorMsg = 'Please enter a valid phone number';
    try {
      const number = phoneUtil.parseAndKeepRawInput(value, 'AU');
      const phoneValid = phoneUtil.isValidNumber(number);

      return phoneValid ? undefined : errorMsg;
    } catch (e) {
      return errorMsg;
    }
  }
}

export function validateMobilePhoneNumber(value: string) {
  if (value) {
    const errorMsg = 'Please enter a valid mobile phone number';
    try {
      const number = phoneUtil.parseAndKeepRawInput(value, 'AU');
      const phoneValid = phoneUtil.isValidNumber(number);

      const isMobile = phoneUtil.getNumberType(number) === 1; // 1 for mobile, 0 for landline
      const isValid = phoneValid && isMobile;

      return isValid ? undefined : errorMsg;
    } catch (e) {
      return errorMsg;
    }
  }
}

export function validateEmail(value: string) {
  const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return emailRegex.test(value)
    ? undefined
    : 'Please enter a valid email address';
}

export function validatePasswordsMatch(
  password: ?string,
  passwordConfirmation: ?string
) {
  if (passwordConfirmation) {
    return password === passwordConfirmation
      ? undefined
      : 'Passwords do not match';
  }
  return 'Required';
}

let lastId = 0;

export function uniqueId(prefix: string = 'id') {
  lastId++;
  return `${prefix}${lastId}`;
}

export function toCapitalizedWords(name: string = ''): string {
  const words = name.match(/[A-Za-z][a-z]*/g);
  if (words) {
    return words.map(capitalize).join(' ');
  }
  return name;
}

function capitalize(word: string): string {
  return word.charAt(0).toUpperCase() + word.substring(1);
}

export function FirstChild(props: Object) {
  const childrenArray = React.Children.toArray(props.children);
  return childrenArray[0] || null;
}

export function isAdminOfAtLeastOneCustomer(customers: Array<Customer>) {
  if (customers) {
    for (let i = 0; i < customers.length; i++) {
      if (customers[i].permissions && customers[i].permissions.length > 1) {
        return true;
      }
    }
    return false;
  }
  return false;
}

export const orgsCustomerscompressor = createCompressor({
  whitelist: ['organisations', 'customers']
});



// WEBPACK FOOTER //
// ./src/helpers.js